// Connection status constants for family finding
export const ConnectionStatus = {
  CONFIRMED: 'confirmed',
  POTENTIAL: 'potential',
  EXPLORING: 'exploring',
  RULED_OUT: 'ruled-out'
};

// Placement status for child welfare case planning
export const PlacementStatus = {
  NOT_APPLICABLE: 'not_applicable',
  POTENTIAL_TEMPORARY: 'potential_temporary',
  POTENTIAL_PERMANENT: 'potential_permanent',
  CURRENT_TEMPORARY: 'current_temporary',
  CURRENT_PERMANENT: 'current_permanent',
  RULED_OUT: 'ruled_out'
};

export const DiscoverySource = {
  WORKER_INTERVIEW: 'worker_interview',
  DOCUMENT_SEARCH: 'document_search',
  EXTERNAL_SEARCH: 'external_search',
  FAMILY_SUGGESTION: 'family_suggestion',
  PUBLIC_RECORDS: 'public_records',
  SOCIAL_MEDIA: 'social_media',
  OTHER: 'other'
};

export const CONNECTION_STATUS_CONFIG = {
  [ConnectionStatus.CONFIRMED]: {
    label: 'Confirmed',
    color: '#10b981', // green
    lineStyle: 'solid',
    description: 'Verified family connection'
  },
  [ConnectionStatus.POTENTIAL]: {
    label: 'Potential',
    color: '#f59e0b', // orange
    lineStyle: 'dashed',
    description: 'Possible connection requiring verification'
  },
  [ConnectionStatus.EXPLORING]: {
    label: 'Exploring',
    color: '#8b5cf6', // purple
    lineStyle: 'dotted',
    description: 'Actively investigating this connection'
  },
  [ConnectionStatus.RULED_OUT]: {
    label: 'Ruled Out',
    color: '#9ca3af', // gray
    lineStyle: 'dashed',
    description: 'Connection determined not viable'
  }
};

export const DISCOVERY_SOURCE_OPTIONS = [
  { value: DiscoverySource.WORKER_INTERVIEW, label: 'Worker Interview' },
  { value: DiscoverySource.DOCUMENT_SEARCH, label: 'Document Search' },
  { value: DiscoverySource.EXTERNAL_SEARCH, label: 'External Search' },
  { value: DiscoverySource.FAMILY_SUGGESTION, label: 'Family Suggestion' },
  { value: DiscoverySource.PUBLIC_RECORDS, label: 'Public Records' },
  { value: DiscoverySource.SOCIAL_MEDIA, label: 'Social Media' },
  { value: DiscoverySource.OTHER, label: 'Other' }
];

export const PLACEMENT_STATUS_CONFIG = {
  [PlacementStatus.NOT_APPLICABLE]: {
    label: 'Not a Placement Option',
    color: '#6b7280', // gray
    icon: '—',
    description: 'Not being considered for placement'
  },
  [PlacementStatus.POTENTIAL_TEMPORARY]: {
    label: 'Potential Temporary',
    color: '#3b82f6', // blue
    icon: '⏱️',
    description: 'Being evaluated for temporary placement'
  },
  [PlacementStatus.POTENTIAL_PERMANENT]: {
    label: 'Potential Permanent',
    color: '#8b5cf6', // purple
    icon: '🏠',
    description: 'Being evaluated for permanent placement'
  },
  [PlacementStatus.CURRENT_TEMPORARY]: {
    label: 'Current Temporary',
    color: '#06b6d4', // cyan
    icon: '📍',
    description: 'Child currently in temporary placement here'
  },
  [PlacementStatus.CURRENT_PERMANENT]: {
    label: 'Current Permanent',
    color: '#10b981', // green
    icon: '✓',
    description: 'Child currently in permanent placement here'
  },
  [PlacementStatus.RULED_OUT]: {
    label: 'Ruled Out for Placement',
    color: '#ef4444', // red
    icon: '✗',
    description: 'Determined unsuitable for placement'
  }
};

export const PLACEMENT_STATUS_OPTIONS = [
  { value: PlacementStatus.NOT_APPLICABLE, label: 'Not a Placement Option' },
  { value: PlacementStatus.POTENTIAL_TEMPORARY, label: 'Potential Temporary Placement' },
  { value: PlacementStatus.POTENTIAL_PERMANENT, label: 'Potential Permanent Placement' },
  { value: PlacementStatus.CURRENT_TEMPORARY, label: 'Current Temporary Placement' },
  { value: PlacementStatus.CURRENT_PERMANENT, label: 'Current Permanent Placement' },
  { value: PlacementStatus.RULED_OUT, label: 'Ruled Out for Placement' }
];

export const getConnectionStatusConfig = (status) => {
  return CONNECTION_STATUS_CONFIG[status] || CONNECTION_STATUS_CONFIG[ConnectionStatus.CONFIRMED];
};

export const getPlacementStatusConfig = (status) => {
  return PLACEMENT_STATUS_CONFIG[status] || PLACEMENT_STATUS_CONFIG[PlacementStatus.NOT_APPLICABLE];
};
